/****************************************************
 * Module Name:  ConsigneeMasterProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class ConsigneeMasterProxy {

    static GetAllConsignee = (hasmapping, callback) => {
        let params = {
            hasmapping: hasmapping
        }

        restAPICall(
            Constants.UTILITY_URL + "/consignee",
            "get",
            undefined,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


    static AddConsignee = (consignee, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/consignee",
            "post",
            undefined,
            undefined,
            JSON.stringify(consignee),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateConsignee = (consignee, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/consignee",
            "put",
            undefined,
            undefined,
            JSON.stringify(consignee),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CheckConsigneeNameAvailable = (consigneename, callback) => {
        let params = {
            consigneename: consigneename,
        };

        restAPICall(
            Constants.UTILITY_URL + "/consignee/available",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllMappedUserMini = (callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/consignee/mini",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static getConsigneeByIds = (data, callback) => {
        restAPICall(
            Constants.UTILITY_URL + `/consignee/multiple`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}